import { render, staticRenderFns } from "./student-login-way3.vue?vue&type=template&id=30ceab1f&lang=pug&"
import script from "./student-login-way3.vue?vue&type=script&lang=js&"
export * from "./student-login-way3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports